import { defineStore } from 'pinia'
import { parseRecentVisits, addRecentVisit } from '@/utils/menu-catalog'

export const useRecentVisitsStore = defineStore('recent-visits', {
  state: () => ({ accountId: null, entries: [] }),
  actions: {
    load(userId) {
      this.accountId = userId == null ? null : String(userId)
      try {
        this.entries = this.accountId == null ? [] : parseRecentVisits(localStorage.getItem(`ais:recent-visits:${this.accountId}`))
      } catch { this.entries = [] }
    },
    record(userId, path) {
      if (userId == null) return
      // 重新读取以合并其他标签页中最近打开的功能。
      this.load(userId)
      this.entries = addRecentVisit(this.entries, path)
      try { localStorage.setItem(`ais:recent-visits:${this.accountId}`, JSON.stringify(this.entries)) } catch { /* 禁用存储时仍保留本次会话记录。 */ }
    }
  }
})
